var _circle, _path, _path2, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSamsaraLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 410,
    height: 410,
    viewBox: "0 0 410 410",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 205,
    cy: 205,
    r: 205,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205 400C153.283 400 103.684 379.455 67.1142 342.886C30.5446 306.316 10 256.717 10 205C10 153.283 30.5446 103.684 67.1142 67.1142C103.684 30.5446 153.283 10 205 10V205L205 400Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M205 10C256.717 10 306.316 30.5446 342.886 67.1142C379.455 103.684 400 153.283 400 205C400 256.717 379.455 306.316 342.886 342.886C306.316 379.455 256.717 400 205 400L205 205L205 10Z",
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 205,
    cy: 205,
    r: 115,
    fill: "#3F013D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamsaraLogo);
export default __webpack_public_path__ + "static/media/Samsara_Logo.fdc3e409762ab81016dbbb8264686d37.svg";
export { ForwardRef as ReactComponent };